module.exports = __webpack_public_path__ + "img/vip4.e135e47b.jpg";